module.exports = __webpack_public_path__ + "static/media/useroutline.30641ce5.svg";